export { LineClamp, type LineClampProps } from './LineClamp';
export {
  lineClampVariants,
  type LineClampVariantProps,
} from './line-clamp.variants';
